// A3 (Addendum 3): staff app vs customer pages on separate domains.
// Build-time env (never hard-coded): REACT_APP_APP_URL (app.soqdigitalprint.com)
// and REACT_APP_PUBLIC_URL (soqdigitalprint.com). Unset = one domain (dev).
// Pure helpers (no imports) so Jest can test them.

const PUBLIK = [/^\/n\//, /^\/c\//, /^\/acc\//, /^\/tracking\//, /^\/tv\/?$/];

export const jalurPublik = (path) => PUBLIK.some((r) => r.test(path || ""));

const bersih = (u) => (u || "").replace(/\/+$/, "");

// Link for a customer page (e.g. "/tracking/<token>").
export function urlPublik(path, publicUrl, origin) {
  return `${bersih(publicUrl) || bersih(origin)}${path}`;
}

// Where to send the browser instead (null = stay). A staff page opened on
// the customer domain goes to the app domain; customer pages stay anywhere.
export function arahUlang(loc, appUrl, publicUrl) {
  const app = bersih(appUrl);
  const pub = bersih(publicUrl);
  if (!app || !pub || app === pub) return null;
  if (loc.origin !== pub || jalurPublik(loc.pathname)) return null;
  return `${app}${loc.pathname}${loc.search || ""}${loc.hash || ""}`;
}
